
define('text!templates/appMain/privilegedMain/qm/policies/editors/evaluationFormSelectorNameList.html',[],function () { return '<!-- ko foreach: selectedForm -->\n<div class="evaluation-form-name" data-bind="text: name"></div>\n<!-- /ko -->';});

